export default "__VITE_ASSET__hoyGhED0__"